import { FormState } from 'components/elements';
import IndeterminateCheckbox from 'components/elements/table/table-checkbox';
import { useWatch } from 'react-hook-form';

import styles from './styles.module.css';

export function HeaderCheckbox(props: {
  name;
  dispatch;
  isSelected?: boolean;
}) {
  const value = useWatch({
    name: props.name,
  });

  const indeterminate = (value || []).some((curr) => curr.isSelected);
  const allChecked = (value || []).every((curr) => curr.isSelected);

  return (
    <FormState>
      {({ editable }) => (
        <div className={styles.checkboxCenter}>
          <IndeterminateCheckbox
            indeterminate={indeterminate}
            checked={allChecked}
            disabled={
              !editable || (props.isSelected !== undefined && !props.isSelected)
            }
            onChange={(event) => {
              props.dispatch?.({
                type: 'isSelected',
                value: event.currentTarget.checked,
              });
            }}
          />
        </div>
      )}
    </FormState>
  );
}
